import { PropsWithChildren, ReactElement } from 'react';

import { IonCard } from '@ionic/react';
import { Color } from '@ionic/core';
import classNames from 'classnames';

import { BoxContent } from './BoxContent/BoxContent';

import styles from './Box.module.scss';

export type BoxProps = PropsWithChildren<{
  color?: Color;
  className?: string;
}>;

interface BoxComponent {
  (props: BoxProps): ReactElement;
  Content: typeof BoxContent;
}

export const Box: BoxComponent = ({ children, color, className }) => {
  return (
    <IonCard
      mode="ios"
      color={color}
      className={classNames(styles.root, className)}
    >
      {children}
    </IonCard>
  );
};

Box.Content = BoxContent;
